import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';

import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AccordionModule } from 'ngx-bootstrap/accordion';

//import { ChipsModule, InputTextModule } from '../../lib/primeng/primeng';
import { CategoryProviderComponent } from './categoryprovider.main';

@NgModule({
    declarations: [CategoryProviderComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        ModalModule.forRoot(),
        AlertModule.forRoot(),
        AccordionModule.forRoot(),
    ],
    providers: [SiteServices],

    bootstrap: [CategoryProviderComponent],
})
export class CategoryProviderModule {}
